import React,{useState,useEffect,useRef} from "react";


import {triangle} from "../../static/images"



import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'


import BodyHeader from "./components/body_header"
import BodyParagraph from "./components/body_paragraph"
import QuoteSection from "./components/quote-section"


import {professorship_data as data} from "../store"
import {isMobile} from "react-device-detect";

import Overlay from "./components/overlay"

const header="OUR PROFESSORSHIPS";
const subheader="Find out more about our professorships and their impact on learning and teaching"

const bodyHeader_0="Introduction";
const bodyPara_0="The NIE appoints distinguished professors from around the world under our professorships. As a student, you will have the opportunity to learn from these eminent educators.";

const bodyHeader_1="Find out more about our professorships"

const readMoreLink=(
    <>
    <br/><br/>
    <a href="https://www.ntu.edu.sg/nie/faculty/professorships" target="_blank">Read more about the Professorships</a>
    </>
);

const content={
    bodyPara_0:[
        <>
        The NIE appoints distinguished professors from around the world under our professorships. Whether you are our student, faculty member or alumnus, join us and learn from these eminent educators during their public lectures.
        {readMoreLink}
        </>,
        <>
        The NIE appoints distinguished professors from around the world under our professorships. As a student, you will have the opportunity to learn from these eminent educators.
        {readMoreLink}
        </>,
        <>
        {/* “It was clear to me then, as it continues to be now, that NIE was uniquely positioned to prepare the nation's teachers, produce ground-breaking research about teaching and learning, and be a major contributor to excellence in education worldwide.”
        <br/><br/>
        ~ Marilyn Cochran-Smith, 1<sup>st</sup> C J Koh Professor, Cawthorne Professor of Teacher Education for Urban Schools, Lynch School of Education, Boston College
        <br/><br/> */}
        The NIE appoints distinguished professors from around the world under our professorships. Students and researchers at the NIE have the opportunity to learn from these eminent educators.
        {readMoreLink}
        </>
    ],
     vidUrls:["https://www.youtube.com/embed/mAQxWV3XM2M?si=THguyw_wFUrzRF41"],
    quote_0:[
        "",
        "",
        {
            quote:"“It was clear to me then, as it continues to be now, that NIE was uniquely positioned to prepare the nation's teachers, produce ground-breaking research about teaching and learning, and be a major contributor to excellence in education worldwide.”",
            author:<>~ Marilyn Cochran-Smith, 1<sup>st</sup> C J Koh Professor, Cawthorne Professor of Teacher Education for Urban Schools, Lynch School of Education, Boston College</>
        }
    ]
}

export default function Professorship(props){
    const {onCloseCallback,onOpenCallback,persona,show,setShow}=props;

    const personaIndex = Number.isInteger(persona)
        ? Math.min(Math.max(persona, 0), content.bodyPara_0.length - 1)
        : 0;

    const [selected, setSelected] = useState(0);
    const cardStripRef=useRef(null);
    const dragStateRef=useRef({startX:0,scrollLeft:0});
    const [isDragging,setIsDragging]=useState(false);

    const quoteEntry = personaIndex===2 ? content.quote_0[personaIndex] : null;

    const getClientX=(event)=>{
        if(event.touches && event.touches.length>0){
            return event.touches[0].clientX;
        }
        return event.clientX;
    }

    const startDrag=(event)=>{
        const container=cardStripRef.current;
        if(!container){
            return;
        }
        setIsDragging(true);
        dragStateRef.current={
            startX:getClientX(event),
            scrollLeft:container.scrollLeft
        };
    }

    const endDrag=()=>{
        setIsDragging(false);
    }

    const onDrag=(event)=>{
        if(!isDragging){
            return;
        }
        if(event.cancelable){
            event.preventDefault();
        }
        const container=cardStripRef.current;
        if(!container){
            return;
        }
        const currentX=getClientX(event);
        const delta=currentX-dragStateRef.current.startX;
        container.scrollLeft=dragStateRef.current.scrollLeft-delta;
    }

    const cards=data.map((item,index)=>(
    <div onClick={()=>{setSelected(index);}} key={`card-${index}`} className={`${index===selected?"active":""} ${index===0?"round-corners-left":"ml-2"} ${index===data.length-1?"round-corners-right":""} card-btn clickable`}>
        <img alt={item.name} src={item.image.default}></img>
        <div className="text-wrapper">
            <span className="name">{item.name}</span>
            <span className="title">
                {item.title}
            </span>
        </div>
    </div>))



    var onClose=()=>{
        setShow(false);
        setSelected(0);
    }

    useEffect(() => {
        if(show){
            onOpenCallback();
        }
        else{
            onCloseCallback();
        }
        
    }, [show]);

    if(!show){
        return (<></>)
    }
        
        return(<div className={`${isMobile?"professorship-container-mobile":"professorship-container"} animate__animated animate__fadeIn animate__faster`}>
        
        <Overlay  header={header} subheader={subheader} onClose={onClose}>

            <Row className="w-100">   
                <BodyHeader header={bodyHeader_0}></BodyHeader>    
            </Row>

            {personaIndex===2?
            <Row className="w-100 mb-2">
                <QuoteSection
                    quote={quoteEntry?.quote || ""}
                    author={quoteEntry?.author || ""}
                ></QuoteSection>
            </Row>
            :<></>}
                    
            <Row className="w-100">  
                <BodyParagraph paragraph={content.bodyPara_0[personaIndex]}></BodyParagraph>
            </Row>

            <Row className="w-100">
                <Col xs={{span:10,offset:1}}>
                    <div className="aspect-ratio-16-9">
                        <iframe title="" className="prefessorship-video" src={content.vidUrls[0]} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    </div>
                </Col>
             </Row>

            <Row className="w-100 mt-4">   
                <BodyHeader header={bodyHeader_1}></BodyHeader>    
            </Row>

            <Row>
                <Col xs={{span:10,offset:1}} className="mt-3">
                    <div
                        ref={cardStripRef}
                        className={`professorship-card-strip ${isDragging?"dragging":""}`}
                        onMouseDown={startDrag}
                        onMouseUp={endDrag}
                        onMouseLeave={endDrag}
                        onMouseMove={onDrag}
                        onTouchStart={startDrag}
                        onTouchEnd={endDrag}
                        onTouchMove={onDrag}
                    >
                        {cards}
                    </div>
                </Col>
            </Row>
            
            <Row className="w-100">
                <Col xs={{span:10,offset:1}} className="mt-4 d-flex flex-column">
                    <div style={{width:`${100/data.length}%`,transform:`translate(${selected*100}%,3px)`}} className="triangle-wrapper">
                        <img alt="triangle" src={triangle.default}></img>
                    </div>     
                </Col>
            </Row>

                <Row className="w-100 m-0">
                    <Col xs={{span:10,offset:1}} className="body-container">
                        <Col xs={12}>
                            <h1 className="name">{data[selected].name}</h1>
                        </Col>
                        <Col xs={12}>
                        <a className="prof-card-link" href={data[selected].link} target="_blank" rel="noopener noreferrer">
                            <p className="title">{data[selected].title}</p></a>
                            <div className="underline"></div>
                        </Col>
                        
                        <Col  xs={11}>
                            <p className="body-paragraph mt-4">{data[selected].intro}</p>
                            {data[selected].videolink?(
                            <div className="aspect-ratio-16-9 mt-4">
                                <iframe
                                    title={`${data[selected].name}-video`}
                                    className="professorship-card-video"
                                    src={data[selected].videolink}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                            ):null}
                        </Col>
                    
                </Col>
            </Row>

        </Overlay>
        
    </div>);
};
